module.exports = "<div class=\"container\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/index/index.component.html
// module id = ../../../../../src/app/index/index.component.html
// module chunks = main